import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

/** A repeatable Collection rendered as a dashed "item template" container holding its child fields. */
export const CollectionBox = styled.div`
  flex: 1 1 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  border: 1px dashed var(--neutral-200, #c3ccd5);
  border-radius: 0.5rem;
  padding: 0.875rem 1rem;
  background-color: #f4f6fb;
`

export const CollectionTitle = styled.div`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
`

export const CollectionMeta = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  margin-top: 0.125rem;
`

/** Footer of a collection box: Add Field on the left, Edit Collection link on the right, one row. */
export const CollectionFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
`
